import React from 'react';

import { TabsContent } from '@/components/ui/tabs';
import { Pagination } from '../../../../../../shared/components/Pagination';
import { TABS_CONFIG } from '../../../../constants';
import { useConversations } from '../../../../hooks';
import ConversationTile from './ConversationTile';

const Skeleton = () => (
  <>
    {Array.from({ length: 5 }, (_, i) => (
      <ConversationTile.Skeleton key={i} />
    ))}
  </>
);

const ConversationsList = () => {
  const {
    conversationsList: conversations,
    handlePageChange,
    isLoadingList: isLoading,
    pagination,
  } = useConversations();

  return TABS_CONFIG.map(({ value }) => (
    <TabsContent
      className="flex flex-col gap-2 p-3 overflow-y-auto"
      key={value}
      value={value}
    >
      {isLoading ? (
        <Skeleton />
      ) : (
        <>
          {conversations.map((conversation) => (
            <ConversationTile conversation={conversation} key={conversation.id} />
          ))}

          <Pagination
            currentPage={pagination.currentPage}
            isLoading={isLoading}
            onPageChange={handlePageChange}
            totalPages={pagination.totalPages}
          />
        </>
      )}
    </TabsContent>
  ));
};

export default ConversationsList;
